export default class staff {
  firstName: string;
  lastName: string;
  emailId: string;
  contactNumber: string;
  countryCode:string;

  constructor() {
    this.firstName = '';
    this.lastName = '';
    this.emailId = '';
    this.contactNumber = '';
    this.countryCode = '+65'
  }
}



// WEBPACK FOOTER //
// ./src/app/authentication/signup/signup.staff.model.ts